import { render, staticRenderFns } from "./AccountNumber.vue?vue&type=template&id=2f30a48a"
import script from "./AccountNumber.vue?vue&type=script&lang=js"
export * from "./AccountNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports